/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrackingShipmentState } from './TrackingShipmentState';
import {
    TrackingShipmentStateFromJSON,
    TrackingShipmentStateFromJSONTyped,
    TrackingShipmentStateToJSON,
    TrackingShipmentStateToJSONTyped,
} from './TrackingShipmentState';

/**
 * 
 * @export
 * @interface GetTrackingDetails
 */
export interface GetTrackingDetails {
    /**
     * 
     * @type {TrackingShipmentState}
     * @memberof GetTrackingDetails
     */
    state: TrackingShipmentState;
    /**
     * 
     * @type {string}
     * @memberof GetTrackingDetails
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTrackingDetails
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTrackingDetails
     */
    companyName?: string;
}



/**
 * Check if a given object implements the GetTrackingDetails interface.
 */
export function instanceOfGetTrackingDetails(value: object): value is GetTrackingDetails {
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function GetTrackingDetailsFromJSON(json: any): GetTrackingDetails {
    return GetTrackingDetailsFromJSONTyped(json, false);
}

export function GetTrackingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTrackingDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'state': TrackingShipmentStateFromJSON(json['state']),
        'id': json['id'] == null ? undefined : json['id'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
    };
}

  export function GetTrackingDetailsToJSON(json: any): GetTrackingDetails {
      return GetTrackingDetailsToJSONTyped(json, false);
  }

  export function GetTrackingDetailsToJSONTyped(value?: GetTrackingDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'state': TrackingShipmentStateToJSON(value['state']),
        'id': value['id'],
        'companyId': value['companyId'],
        'companyName': value['companyName'],
    };
}

